import $ from 'jquery';
import 'jquery.cookie';
import cartPromotions from './cart-promotions';
import updateRegistration from './registration';
import products from './products';
import checkForCheckout from './checkout-fallback';
var $closeButton = $(".wpfront-close"),
    $fullBar = $("#wpfront-notification-bar-spacer"),
    // $instagramFeed = $("#sb_instagram"),
    $barCookie = $.cookie("wpfront-notification-bar-keep-closed");

if ($barCookie == '1') {
    closeBar();
}
if ($(".product-unavailable")[0] && $('.bc-btn--add_to_cart')[0]) {
    $('.product-availability-container').addClass('hidden');
}

$closeButton.insertAfter($("#wpfront-notification-bar table"));
$closeButton.attr("tabindex", "0");
$closeButton.html("<i aria-hidden='true'>X</i>");
$closeButton.attr("aria-label", "close");
$closeButton.attr("role", "button");
$fullBar.attr("aria-label", "Alert Bar");
$fullBar.attr("tabindex", "0");


$closeButton.keypress(function (event) {
    if (event.which == 13) closeBar();
});

$closeButton.click(closeBar);

function closeBar() {
    $fullBar.addClass("close");
    $fullBar.attr("aria-hidden", "true");
    $.cookie("wpfront-notification-bar-keep-closed", "1");
}

$(document).on('facetwp-refresh', function () {
    if (FWP.loaded) { // after the initial pageload
        FWP.setHash();
        $('html,body').animate({ scrollTop: 0 }, 'slow');
        window.location.reload();
        return false;
    }
});
$('input#bc-account-register-phone').keypress(function (e) {
    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        return false;
    }
});
$('input#bc-account-profile-phone').keypress(function (e) {
    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        return false;
    }
});
products($);
cartPromotions();
updateRegistration($);
checkForCheckout($);
// $instagramFeed.bind("DOMSubtreeModified", function() {
//     $(this).find("a").attr("aria-label","Instagram Image");
// });
// $instagramFeed.attr("aria-label","instagram image feed");
